// Phase 4.5B — Founder trust block on the Next Steps ascension page.
// Pure presentation. No props, no state, no hooks. Text-only signature
// (no photo, no image asset) per the 4.5B plan §11. Copy is CEO-locked
// and must remain byte-identical (EXACT-STRING-NS-021 / 022 / 023).
export default function FounderTrustBlock() {
  return (
    <section
      className="sf-card"
      style={{ borderColor: "var(--sf-gold-dim)", marginTop: 48 }}
      data-testid="founder-block"
    >
      <div className="sf-eyebrow" style={{ marginBottom: 12 }} data-testid="founder-block-eyebrow">
        FROM THE FOUNDER
      </div>
      <p
        className="sf-muted-text"
        style={{ marginBottom: 18, lineHeight: 1.7, maxWidth: 720 }}
        data-testid="founder-block-body"
      >
        Every consultation and implementation request comes directly to me. I review every audit before any engagement begins. There is no sales team, no handoff, no automated upsell — just a direct conversation about whether we can help.
      </p>
      <cite
        className="sf-mono"
        style={{ fontStyle: "normal", fontSize: 13, letterSpacing: "0.04em", color: "var(--sf-muted)" }}
        data-testid="founder-block-attribution"
      >
        — Arvis Lawson, Founder, SystemForge AI
      </cite>
    </section>
  );
}
